<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          label="Name"
          :readonly="readonly"
          :disabled="disabled"
          v-model="nameValue"
          :rules="[Required('Name')]"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="8">
        <EmailInput
          :label="'E-Mail'"
          :email-address="emailAddressValue"
          :is-required="true"
          :readOnly="readonly"
          :disabled="disabled"
          @emailChange="(newValue) => this.emailAddressValue = newValue"
        ></EmailInput>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="10" md="8">
        <v-textarea
          label="Notes"
          :readonly="readonly"
          :disabled="disabled"
          v-model="notesValue"
          outlined
        ></v-textarea>
      </v-col>
      <v-col cols="12" sm="2" md="2" class="pt-0" v-if="showDeleteButton">
        <v-btn
          class="mx-1 my-1"
          color="red"
          outlined
          @click="$emit('deleteRecipient', id)"
        >
          <v-icon color="red">delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { EmailInput } from '@/components/emails/index'
import Required from '@/lib/formValidations/required'

export default {
  props: [
    'id',
    'name',
    'emailAddress',
    'notes',
    'readonly',
    'recipientsList',
    'disabled',
    'showDeleteButton'
  ],
  components: {
    EmailInput
  },
  computed: {
    nameValue: {
      get () {
        return this.name
      },
      set (newValue) {
        this.$emit('nameChange', this.id, newValue)
      }
    },
    emailAddressValue: {
      get () {
        return this.emailAddress
      },
      set (newValue) {
        this.$emit('emailChange', this.id, newValue)
      }
    },
    notesValue: {
      get () {
        return this.notes
      },
      set (newValue) {
        this.$emit('notesChange', this.id, newValue)
      }
    }
  },
  methods: {
    Required
  }
}
</script>
